import React from 'react'
import PropTypes from 'prop-types'
import { OnChange } from 'react-final-form-listeners'
import { Form } from 'react-final-form'
import QuestionHeader from './questionHeader'
import { makeStyles } from '@material-ui/core'
import TextInput from 'components/input/textInput'

const useStyles = makeStyles(() => ({
  dash: {
    borderBottom: '1px solid #e0e0e0',
    display: 'inline-block',
    width: '50px',
    margin: '25px 10px 0px 10px',
  }
}))

export default function RenderRange(props) {
  const classes = useStyles()
  const { elmIndex, elm, valIndex, valueChange, allowModify } = props
  if (!elm.Value[valIndex]) elm.Value[valIndex] = ['']
  const initialValues = {}
  const name = `elm-${elmIndex}-val-${valIndex}-`
  initialValues[name + 0] = elm.Value[valIndex][0]
  initialValues[name + 1] = elm.Value[valIndex][1]
  const elmValueChange = (values) => {
    valueChange(elmIndex, valIndex, [values[name + 0] || '', values[name + 1] || ''])
  }

  return <div key={elmIndex}>
    <QuestionHeader helpTooltip={elm.ShowHelpTooltip ? elm.HelpTooltip : ''} prompt={elm.Prompt} allowBlanks={!!elm.AllowBlanks} />
    <Form onSubmit={() => { }}
      initialValues={initialValues}
      render={({ values }) => (<>
        <TextInput disabled={!allowModify} label={`${elm.Range1 ? elm.Range1 : ''}`} name={name + 0} required={!elm.AllowBlanks} variant="outlined" validationrule={elm.ValidationRule} fullWidth={false} />
        <OnChange name={name + 0}>
          {() => elmValueChange(values)}
        </OnChange>
        <div className={classes.dash}></div>
        <TextInput disabled={!allowModify} label={`${elm.Range2 ? elm.Range2 : ''}`} name={name + 1} required={!elm.AllowBlanks} variant="outlined" validationrule={elm.ValidationRule} fullWidth={false} />
        <OnChange name={name + 1}>
          {() => elmValueChange(values)}
        </OnChange>
      </>)} //debug: <pre>{JSON.stringify(values, 0, 2)}</pre>
    />
  </div>
}

RenderRange.propTypes = {
  elmIndex: PropTypes.number.isRequired,
  elm: PropTypes.object.isRequired,
  valIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  valueChange: PropTypes.func.isRequired,
  allowModify: PropTypes.bool.isRequired,
}